<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.settlements') }}</h1>
    <div class="filter-bar">
      <el-date-picker v-model="search.settlement_month" type="month" value-format="yyyy-MM" :placeholder="$t('common.month')" class="filter-item" size="small"></el-date-picker>
      <el-select v-model="search.status" clearable :placeholder="$t('common.status')" class="filter-item" size="small">
        <el-option v-for="item in statuses" :key="item.value" :value="item.value" :label="$t(item.labelKey)"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="reload">{{ $t('actions.search') }}</el-button>
    </div>

    <div class="table-scroll">
      <el-table :key="tableLanguage" :data="tableData" border stripe>
        <el-table-column prop="settlement_month" :label="$t('common.month')" min-width="100"></el-table-column>
        <el-table-column prop="pkg" :label="$t('common.packageName')" min-width="150"></el-table-column>
        <el-table-column prop="chn" :label="$t('common.channel')" min-width="120"></el-table-column>
        <el-table-column prop="settlement_currency" :label="$t('common.currency')" min-width="90"></el-table-column>
        <el-table-column prop="converted_recharge_amount" :label="$t('pages.convertedTurnover')" min-width="140"></el-table-column>
        <el-table-column prop="commission_amount" :label="$t('common.commission')" min-width="130"></el-table-column>
        <el-table-column :label="$t('common.status')" min-width="110">
          <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column prop="audited_at" :label="$t('common.auditTime')" min-width="160"></el-table-column>
        <el-table-column :label="$t('common.actions')" min-width="120" class-name="table-actions">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">{{ $t('actions.detail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadData"
    ></el-pagination>

    <el-dialog :title="$t('pages.settlementDetail')" :visible.sync="detailDialogShow" width="760px">
      <div v-if="detail.record" class="detail-grid">
        <div><span>{{ $t('common.month') }}</span><strong>{{ detail.record.settlement_month }}</strong></div>
        <div><span>{{ $t('common.status') }}</span><strong>{{ statusText(detail.record.status) }}</strong></div>
        <div>
          <span>{{ $t('common.sourceAmount') }}</span>
          <div v-if="detail.details.length" class="metric-list">
            <div v-for="item in detail.details" :key="item.source_currency || 'empty'" class="metric-row">
              <span>{{ item.source_currency || '-' }}</span>
              <strong>{{ item.source_amount }}</strong>
            </div>
          </div>
          <strong v-else>0</strong>
        </div>
        <div><span>{{ $t('pages.convertedTurnover') }}</span><strong>{{ detail.record.converted_recharge_amount }}</strong></div>
        <div><span>{{ $t('common.commission') }}</span><strong>{{ detail.record.commission_amount }}</strong></div>
        <div><span>{{ $t('common.auditTime') }}</span><strong>{{ detail.record.audited_at || '-' }}</strong></div>
      </div>
      <h2 class="section-title">{{ $t('pages.currencyDetails') }}</h2>
      <div class="table-scroll">
        <el-table :data="detail.details" border stripe size="mini">
          <el-table-column prop="source_currency" :label="$t('common.sourceCurrency')" min-width="120"></el-table-column>
          <el-table-column prop="source_amount" :label="$t('common.sourceAmount')" min-width="130"></el-table-column>
          <el-table-column prop="target_currency" :label="$t('common.targetCurrency')" min-width="120"></el-table-column>
          <el-table-column prop="exchange_rate" :label="$t('common.exchangeRate')" min-width="120"></el-table-column>
          <el-table-column prop="target_amount" :label="$t('common.targetAmount')" min-width="130"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'Settlements',
  data() {
    return {
      search: { page: 1, size: 20 },
      tableData: [],
      count: 0,
      detailDialogShow: false,
      detail: { record: null, details: [] },
      statuses: [
        { value: 0, labelKey: 'status.pending' },
        { value: 1, labelKey: 'status.settled' },
        { value: 2, labelKey: 'status.hold' }
      ]
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    tableLanguage() {
      return this.$i18nState.language;
    }
  },
  methods: {
    reload() {
      this.search.page = 1;
      this.loadData();
    },
    statusText(status) {
      this.tableLanguage;
      const item = this.statuses.find(one => String(one.value) === String(status));
      return item ? this.$t(item.labelKey) : String(status);
    },
    buildQueryParams() {
      return Object.keys(this.search).reduce((params, key) => {
        const value = this.search[key];
        if (value !== '' && value !== null && value !== undefined) params[key] = value;
        return params;
      }, {});
    },
    async loadData() {
      const resp = await this.$axios.get('/admin/exagent/console/settlements/', { params: this.buildQueryParams() });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.tableData = data.list || [];
      this.count = data.count || 0;
    },
    async openDetail(row) {
      const resp = await this.$axios.get('/admin/exagent/console/settlements/detail/', { params: { id: row.id } });
      if (resp.data.status !== 0) return;
      this.detail = resp.data.data || { record: null, details: [] };
      this.detailDialogShow = true;
    }
  }
};
</script>

<style lang="less" scoped>
.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;

  div {
    border: 1px solid #e6e8ef;
    border-radius: 6px;
    padding: 10px;
  }

  span {
    display: block;
    color: #778094;
    font-size: 12px;
    margin-bottom: 4px;
  }

  strong {
    color: #20283a;
  }
}

.metric-list {
  margin-top: 4px;
}

.metric-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 24px;

  span {
    margin-bottom: 0;
  }

  strong {
    font-size: 15px;
  }
}

.section-title {
  margin: 18px 0 10px;
  font-size: 15px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/Settlements.vue